import httpClient from '@/global/httpClient';
import * as apis from '@/constants/api';

export const getAgreementCheck = (payload) => httpClient.get(apis.getAgreementCheck(payload));

export const makeAgreementSign = (payload) =>
  httpClient.post(apis.makeAgreementSign(payload), null, { ignore: true });

export const getCourseAgreement = (payload) => httpClient.get(apis.getCourseAgreement(payload));

export const getOrderAgreement = (payload) => httpClient.get(apis.getOrderAgreement(payload));
